import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { Sort } from '@angular/material/sort';
import { first } from 'rxjs/operators';
import { AdminProjectService, AdminSchoolService, ContactSearchVM, SearchVM } from '../services/api';
import { AppConfirmService } from '../services/app-confirm.service';
import { FileSaverService } from 'ngx-filesaver'; 

@Component({
  selector: 'app-entity-contacts',
  templateUrl: './entity-contacts.component.html',
  styleUrls: ['./entity-contacts.component.scss']
})
export class EntityContactsComponent implements OnInit {

  data: ContactSearchVM[] = [];
  search: SearchVM = { pageIndex: 1, pageSize: 10, sortExpressions: ["FirstName Desc"] };
  searchText: string = "";
  displayedColumns: string[] = ['firstName', "lastName",'jobTitle', "phone"];
  @ViewChild(MatPaginator) paginator: MatPaginator = <MatPaginator>{};
  @Input()entityId:number = -1;
  @Input()entityType:string = "";
  @Input() isAdmin:boolean = false;
  @Input() headmasterId:number | null | undefined = -1;
  @Input() showDelete:boolean = true;
  @Output()refreshParent:EventEmitter<any> = new EventEmitter<any>();

  constructor(private adminSchool:AdminSchoolService,
    private adminProject:AdminProjectService, 
    private confirm:AppConfirmService,
    private fileService:FileSaverService) { 

  }

  ngOnInit(): void {
    if(this.showDelete){
      this.displayedColumns.push("delete");
    }else{
      this.displayedColumns.push("export");
    }
    if(this.entityType == "school"){
      this.displayedColumns.splice(4, 0, "headMasterId");
    }
    this.getData();
  
  }

  sortColumn(ev: Sort) {
    this.search.sortExpressions = [ev.active.capitalize() + " " + ev.direction];
    this.getData();
    
  }

  getData() {

    if(this.isAdmin){
      if(this.entityType == "school"){

        
        this.adminSchool.adminSchoolGetRelatedContactsPost(this.entityId,this.search).pipe(first()).subscribe(result=>{
          this.data = result.entities ?? [];
          this.paginator.length = result.totalItems ?? 0;
          this.paginator.pageSize = this.search.pageSize ?? 10;
          this.paginator.pageIndex = (this.search.pageIndex ?? 1) - 1

        })
      }else if(this.entityType == "project"){
        console.log(this.search)
        this.adminProject.adminProjectSearchProjectContactsPost(this.entityId,this.search).pipe(first()).subscribe(result=>{
          console.log(result)
          this.data = result.entities ?? [];
          this.paginator.length = result.totalItems ?? 0;
          this.paginator.pageSize = this.search.pageSize ?? 10;
          this.paginator.pageIndex = (this.search.pageIndex ?? 1) - 1

        })
      }
    }else{

    }
    

  }

  pageChanged(event: PageEvent) {
    this.search.pageIndex = event.pageIndex + 1
    this.search.pageSize = event.pageSize;
    this.getData();
  }

  deleteContact(event: Event, row: ContactSearchVM) {
    event.stopPropagation();
    this.confirm.confirm({ message: "Are you sure?", title: "Confirmation" }).pipe(first()).subscribe(answer => {
      if (answer) {
        this.adminSchool.adminSchoolDetachContactGet(this.entityId,row.id!).pipe(first()).subscribe(result => {
          this.getData();
        });
      }
    })

  }

  assignHeadMaster(event: Event, row: ContactSearchVM) {
    event.stopPropagation();
    this.confirm.confirm({ message: "Are you sure about assigning "+ row.firstName + " " +row.lastName +" as Head Teacher?", title: "Confirmation" }).pipe(first()).subscribe(answer => {
      if (answer) {
        this.adminSchool.adminSchoolAssignHeadmasterGet(this.entityId,row.id).pipe(first()).subscribe(result => {
          this.getData();
          this.refreshParent.emit();
        });
      }
    })

  }

  exportCSV() {
    let searchCriteria: SearchVM = {
      filterExpression: null,
      sortExpressions: this.search.sortExpressions,
      pageIndex: null,
      pageSize: null
    };
    if (this.isAdmin) {
      if (this.entityType == "school") {
        this.adminSchool.adminSchoolGetRelatedContactsPost(this.entityId, searchCriteria).pipe(first()).subscribe(result => {
          if (result.entities?.length)
            this.downloadFile(result.entities);
        })
      } else if (this.entityType == "project") {
        this.adminProject.adminProjectSearchProjectContactsPost(this.entityId, searchCriteria).pipe(first()).subscribe(result => {
          if (result.entities?.length)
            this.downloadFile(result.entities);
        })
      }
    }
  }

  downloadFile(entities: ContactSearchVM[]) {
    const header = Object.keys(entities[0]);
    let csv: any = entities.map(row => Object.values(row).join(','));
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');
    var blob = new Blob([csvArray], { type: 'text/csv' })
    this.fileService.save(blob, "contacts.csv");
  }

}
